/**
 * change src attribute of image but with CSS animation
 */

class ChangeImageOnHover {
  constructor(parent) {
    this.minWidth = parent.dataset.minWidth
    this.links = parent.querySelectorAll('[data-hover-image]')
    this.bg = parent.querySelector('[data-menu-bg]')
    this.targetBg = null
    this.currentBg = null
    this.isAnimating = false

    this.links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        this.targetBg = link.dataset.hoverImage
        this.requestUpdate()
      })
      link.addEventListener('mouseleave', () => {
        this.targetBg = null
        this.requestUpdate()
      })
    })
  }

  loadImage(src) {
    return new Promise(resolve => {
      if (this.minWidth && window.innerWidth < this.minWidth) resolve()
      this.bg.onload = resolve
      this.bg.src = src
    })
  }

  runAnimation(show) {
    return new Promise(resolve => {
      this.bg.classList.toggle('animate', show)
      this.bg.ontransitionend = resolve
    })
  }

  async requestUpdate() {
    if (this.isAnimating || this.targetBg === this.currentBg) return
    const targetBgAtThisMoment = this.targetBg
    this.isAnimating = true
    if (this.currentBg !== null) {
      await this.runAnimation(false)
    }
    if (targetBgAtThisMoment !== null) {
      await this.loadImage(targetBgAtThisMoment)
      await this.runAnimation(true)
    }
    this.currentBg = targetBgAtThisMoment
    this.isAnimating = false
    this.requestUpdate()
  }
}

export default ChangeImageOnHover
